module.exports = __webpack_public_path__ + "static/img/Business.e263e0af.jpg";